import React from 'react';
import PropTypes from 'prop-types';

import { getURL } from '../../util';

const icons = {
	media: "cloud_download",
	transcript: "text_fields",
	audio: "volume_up",
	comments: "comment",
	"comment-history": "forum",
	"like-history": "favorite"
}
const Icon = ({ type }) => icons[type] === undefined ? null : <small><i aria-hidden="true" className="material-icons align-text-top mr-3 text-black-secondary">{icons[type]}</i>&nbsp;</small>;

const MainDownload = ({ download, downloadFile }) => (
	<a className="dropdown-item" href={download.link} onMouseDown={()=>downloadFile(download)}>
		<Icon type={download.code} />
		Download video
	</a>
)

const OtherDownload = ({ download, instance, features, downloadFile }) => (
	<a className="dropdown-item" href={getURL(download, instance)} onClick={downloadFile.bind(this, download)}>
		<Icon type={download.code} />
		{download.label}
	</a>
)

const Downloads = ({ downloads, instance, features, expanded, downloadFile, toggleDownloadMenu }) => (
	<div className={"dropdown"+(expanded?" show":"")}>
		<button aria-expanded={expanded} aria-haspopup="true" aria-label="Toggle download dropdown menu" className="btn unsw-mw-0" type="button" onClick={()=>toggleDownloadMenu()}>
			<i aria-hidden="true" className="material-icons">cloud_download</i>
		</button>
		<div aria-label="Download dropdown menu" className={"dropdown-menu dropdown-menu-right dropdown-menu-sm unsw-mw-0"+(expanded?" show":"")}>
			{downloads.map((download, index)=>(
				download.label==="Media"
					? <MainDownload key={"download-"+index} download={download} downloadFile={downloadFile} />
					: <OtherDownload key={"download-"+index} download={download} instance={instance} features={features} downloadFile={downloadFile} />
			))}
		</div>
	</div>
)

Downloads.propTypes = {
	expanded: PropTypes.bool.isRequired,
	downloads: PropTypes.array.isRequired,
	downloadFile: PropTypes.func.isRequired,
	toggleDownloadMenu: PropTypes.func.isRequired,
	instance: PropTypes.string.isRequired,
	features: PropTypes.object.isRequired
}

export default Downloads;